/* RESPONSIBLE TEAM: team-actions */
import { attr } from '@ember-data/model';

export default class WebhookFilter {
  @attr('string') appIdCode;
  @attr('string') operator;
  @attr('boolean') attributeName;
  @attr('string') value;
}
